module.exports = "/images/pin-audiovideo-active.png?411701ff598fa6f974a08362f3dabe72";